import { useUnreadCount as useInboxUnreadCount } from '@ms/yammer-inbox';
import { useUnseenCount as useNotificationsUnseenCount } from '@ms/yammer-notifications';

export const useTotalBadgeCount = (): number => {
  const notificationsUnseenCount = useNotificationsUnseenCount();
  const inboxUnreadCount = useInboxUnreadCount();

  return notificationsUnseenCount + inboxUnreadCount;
};
